import {configureStore} from "@reduxjs/toolkit";
import loginReducer from "../features/login/loginSlice";
import topMenuReducer from "../features/top-menu/topMenuSlice";
import applicantReducer from "../features/applicant/applicantSlice";
import driverReducer from "../features/driver/driverSlice";
import requestReducer from "../features/request/requestSlice";
import commonStatesReducer from "../features/common-states/commonStatesSlice";
import reportReducer from "../features/report/reportSlice"
import userReducer from "../features/user/userSlice"

export const store = configureStore({
    reducer:{
        commonStates: commonStatesReducer,
        login: loginReducer,
        topMenu: topMenuReducer,
        applicant: applicantReducer,
        driver: driverReducer,
        request: requestReducer,
        report: reportReducer,
        user: userReducer
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})
